import React, { FC, useState } from 'react';
import { Box, TextField, Button, InputAdornment, FormControl, Select, MenuItem } from '@mui/material';
import { Search, Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import FreeTextFilterComponent from 'components/users/shared/free-text-filter/free-text-filter.component';

type LabsHeaderProps = {
    onSearch: (searchTerm: string) => void;
    onConnectLabs: () => void;
    onStatusFilter: (status: 'all' | 'active' | 'inactive') => void;
    statusFilter: 'all' | 'active' | 'inactive';
    searchTerm: string;
};

const ManageLabsActions: FC<LabsHeaderProps> = ({
    onSearch,
    onConnectLabs,
    onStatusFilter,
    statusFilter,
    searchTerm,
}) => {
    const { t: translate } = useTranslation(['common', 'organization', 'users']);

    const handleFreeTextChange = (freeTextInput: string) => {
        onSearch(freeTextInput);
    };
    const handleStatusChange = (event: any) => {
        onStatusFilter(event.target.value);
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <FreeTextFilterComponent
                    freeTextFilterChange={handleFreeTextChange}
                    label="SEARCH LAB ORG NUMBER"
                    fullWidth={false}
                    value={searchTerm}
                />
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <Select value={statusFilter} onChange={handleStatusChange}>
                        <MenuItem value="all">{translate('users:SHOW_ALL')}</MenuItem>
                        <MenuItem value="active">{translate('users:SHOW_ACTIVE')}</MenuItem>
                        <MenuItem value="inactive">{translate('users:SHOW_INACTIVE')}</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Button variant="contained" startIcon={<Add />} onClick={onConnectLabs}>
                {translate('organization:CONNECT_TO_LAB')}
            </Button>
        </Box>
    );
};

export default ManageLabsActions;
